export default "__VITE_ASSET__WvV0UmTR__"